import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-drawing-upload',
  templateUrl: './project-drawing-upload.component.html',
  styleUrls: ['./project-drawing-upload.component.css']
})
export class ProjectDrawingUploadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
